import React from 'react';
import { t, Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { Grid, H3, P } from '@decisiv/ui-components';
import RadioGroup from '@decisiv/ui-components/lib/components/RadioGroup';
import SectionRow from '../../components/SectionRow';

export default function AutoEnable({ handleForm }) {
  return (
    <SectionRow>
      <Grid.Column padding={0} span="3">
        <H3>
          <Trans>Auto Enable</Trans>
        </H3>
      </Grid.Column>
      <Grid.Column padding={0}>
        <P shade={1} size="small" marginBottom={1}>
          <Trans>
            Mark this as a core integration so it is automatically enabled by
            default when a new location is created.
          </Trans>
        </P>
        <RadioGroup
          name="auto_enable"
          items={[
            { label: t`Yes`, value: 'true' },
            { label: t`No`, value: 'false' },
          ]}
          onChange={(e) => handleForm({ event: e })}
          defaultValue="false"
          onClick={(event) => {
            event.stopPropagation();
          }}
        />
      </Grid.Column>
    </SectionRow>
  );
}

AutoEnable.propTypes = {
  handleForm: PropTypes.func.isRequired,
};
